<template>
    <v-card style="height: 400px;">
        <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="subtitle-1 text-center" cols="12">
                <span v-text="$t('edit_areas.loading_map')"></span>
            </v-col>
            <v-col cols="6">
                <v-progress-linear class="progress" color="primary" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
        </v-row>
    </v-card>
</template>

<script> 
export default {
    name: 'LoadingStep'

}
</script>

<style>

</style>